import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiCheck } from "react-icons/fi";
import StepOne from "./stepOne";
import StepTwo from "./stepTwo";

const STEPS = [
  { num: 1, label: "Connect Source" },
  { num: 2, label: "Customize & Publish" },
];

export default function Create() {
  const [step, setStep] = useState(1);
  const [allUrls, setAllUrls] = useState([]);
  const navigate = useNavigate();

  return (
    /* -m-6 removes the DashboardLayout p-6 so we own the full area */
    <div className="-m-6 flex flex-col h-[calc(100vh-4rem)]">

      {/* ── Fixed sub-header ── */}
      <div className="shrink-0 bg-white border-b px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            onClick={() => step === 1 ? navigate(-1) : setStep(1)}
            className="w-8 h-8 rounded-lg hover:bg-gray-100 flex items-center justify-center transition text-gray-500 shrink-0"
          >
            <FiArrowLeft size={16} />
          </button>
          <div>
            <h1 className="font-bold text-gray-900 text-base leading-tight">Create New Chatbot</h1>
            <p className="text-xs text-gray-400 mt-0.5">Step {step} of {STEPS.length} — {STEPS[step - 1].label}</p>
          </div>
        </div>

        {/* Stepper */}
        <div className="flex items-center gap-2 shrink-0">
          {STEPS.map((s, i) => {
            const isDone   = step > s.num;
            const isActive = step === s.num;
            return (
              <div key={s.num} className="flex items-center gap-2">
                <div className="flex items-center gap-2">
                  <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold transition-all ${
                    isDone   ? "bg-green-500 text-white" :
                    isActive ? "bg-primary text-white shadow-sm shadow-primary/30" :
                               "bg-gray-100 text-gray-400"
                  }`}>
                    {isDone ? <FiCheck size={12} /> : s.num}
                  </div>
                  <span className={`text-sm font-medium hidden md:block ${
                    isActive ? "text-gray-900" : isDone ? "text-green-600" : "text-gray-400"
                  }`}>
                    {s.label}
                  </span>
                </div>
                {i < STEPS.length - 1 && (
                  <div className={`w-10 h-px mx-1 transition-colors ${step > s.num ? "bg-green-400" : "bg-gray-200"}`} />
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* ── Scrollable content ── */}
      <div className="flex-1 overflow-y-auto bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="grid grid-cols-12 gap-6">
            {step === 1 && (
              <div className="col-span-12">
                <StepOne updateStep={setStep} updateAllUrls={setAllUrls} />
              </div>
            )}
            {step === 2 && (
              <StepTwo updateStep={setStep} allUrls={allUrls} />
            )}
          </div>
        </div>
      </div>

    </div>
  );
}
